export const ROUTES = {
  HOME: '/',
  REGISTER: '/register',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  WAITING: '/waiting',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
